import { queryOptions, useQuery } from '@tanstack/react-query';

import { SecurityInsightsCheckExceptionsGroup } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';

type Params = {
  ruleId: string;
  groups: SecurityInsightsCheckExceptionsGroup[];
  enabled: boolean;
};

const SECURITY_BEST_PRACTICES_CHECK_EXCEPTIONS_RESOURCES_QUERY_KEY =
  'security-best-practices-check-exceptions-resources';

const getBestPracticeCheckExceptionsResourcesQueryKey = ({
  ruleId,
  groups,
}: Pick<Params, 'ruleId' | 'groups'>) =>
  [
    SECURITY_BEST_PRACTICES_CHECK_EXCEPTIONS_RESOURCES_QUERY_KEY,
    ruleId,
    groups,
  ] as const;

const getBestPracticeCheckExceptionsResourcesQueryOptions = ({
  ruleId,
  groups,
  enabled,
}: Params) =>
  queryOptions({
    queryKey: getBestPracticeCheckExceptionsResourcesQueryKey({
      ruleId,
      groups,
    }),
    queryFn: async () => {
      const { data } =
        await apiClient.securityInsights.getCheckExceptionsResources({
          ruleId,
          payload: {
            groups,
          },
        });
      return data.resources ?? [];
    },
    enabled,
  });

export const useBestPracticeCheckExceptionsResourcesQuery = (
  params: Params
) => {
  const {
    isLoading,
    data: resources,
    error,
    refetch,
  } = useQuery(getBestPracticeCheckExceptionsResourcesQueryOptions(params));

  return { isLoading, resources, error, refetch };
};
